var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { connect } from '@formily/react-schema-renderer';
import { Input } from 'antd';
import { PasswordStrength } from '@formily/react-shared-components';
import styled from 'styled-components';
import { mapStyledProps } from '../shared';
export var Password = connect({
    getProps: mapStyledProps
})(styled(function (props) {
    var value = props.value, className = props.className, checkStrength = props.checkStrength, others = __rest(props, ["value", "className", "checkStrength"]);
    return (React.createElement("span", { className: className },
        React.createElement(Input.Password, __assign({}, others, { value: value })),
        checkStrength && (React.createElement(PasswordStrength, { value: String(value) }, function (score) {
            return (React.createElement("div", { className: "password-strength-wrapper" },
                React.createElement("div", { className: "div-1 div" }),
                React.createElement("div", { className: "div-2 div" }),
                React.createElement("div", { className: "div-3 div" }),
                React.createElement("div", { className: "div-4 div" }),
                React.createElement("div", { className: "password-strength-bar", style: {
                        clipPath: "polygon(0 0," + score + "% 0," + score + "% 100%,0 100%)"
                    } })));
        }))));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .password-strength-wrapper {\n    background: #e0e0e0;\n    margin-bottom: 3px;\n    position: relative;\n    .div {\n      position: absolute;\n      z-index: 1;\n      height: 8px;\n      top: 0;\n      background: #fff;\n      width: 1px;\n      transform: translate(-50%, 0);\n    }\n    .div-1 {\n      left: 20%;\n    }\n    .div-2 {\n      left: 40%;\n    }\n    .div-3 {\n      left: 60%;\n    }\n    .div-4 {\n      left: 80%;\n    }\n    .password-strength-bar {\n      position: relative;\n      background-image: -webkit-linear-gradient(left, #ff5500, #ff9300);\n      transition: all 0.35s ease-in-out;\n      height: 8px;\n      width: 100%;\n      margin-top: 5px;\n    }\n  }\n"], ["\n  .password-strength-wrapper {\n    background: #e0e0e0;\n    margin-bottom: 3px;\n    position: relative;\n    .div {\n      position: absolute;\n      z-index: 1;\n      height: 8px;\n      top: 0;\n      background: #fff;\n      width: 1px;\n      transform: translate(-50%, 0);\n    }\n    .div-1 {\n      left: 20%;\n    }\n    .div-2 {\n      left: 40%;\n    }\n    .div-3 {\n      left: 60%;\n    }\n    .div-4 {\n      left: 80%;\n    }\n    .password-strength-bar {\n      position: relative;\n      background-image: -webkit-linear-gradient(left, #ff5500, #ff9300);\n      transition: all 0.35s ease-in-out;\n      height: 8px;\n      width: 100%;\n      margin-top: 5px;\n    }\n  }\n"]))));
export default Password;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/password/index.js
// module id = 2101
// module chunks = 0